const BYE_ID = '__BYE__'

function rotatePlayers(players) {
  return [players[0], players[players.length - 1], ...players.slice(1, players.length - 1)]
}

export function buildRoundRobinFixtures(participants, legs = 1) {
  const cleanParticipants = participants.filter(Boolean)
  if (cleanParticipants.length < 2) {
    return []
  }

  const players = [...cleanParticipants]
  if (players.length % 2 !== 0) {
    players.push(BYE_ID)
  }

  const roundsPerLeg = players.length - 1
  const fixturesPerRound = players.length / 2
  const fixtures = []

  for (let leg = 1; leg <= legs; leg++) {
    let rotation = [...players]

    for (let round = 1; round <= roundsPerLeg; round++) {
      for (let match = 1; match <= fixturesPerRound; match++) {
        let player1Identity = rotation[match - 1]
        let player2Identity = rotation[rotation.length - match]

        if (leg % 2 === 0) {
          const tmp = player1Identity
          player1Identity = player2Identity
          player2Identity = tmp
        }

        const hasBye = player1Identity === BYE_ID || player2Identity === BYE_ID
        const byeWinner = player1Identity === BYE_ID ? player2Identity : player1Identity

        fixtures.push({
          id: `rr-l${leg}-r${round}-m${match}`,
          kind: 'round_robin',
          leg,
          round,
          match,
          player1Identity,
          player2Identity,
          status: hasBye ? 'done' : 'pending',
          winnerIdentity: hasBye ? byeWinner : null,
          score1: null,
          score2: null,
        })
      }

      rotation = rotatePlayers(rotation)
    }
  }

  return fixtures
}

export { BYE_ID }
